import React, { useEffect, useMemo, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import ResearchDisclaimer from "../../Components/Common/ResearchDisclaimer";
import { getResearchStats } from "../../services/userPredictionService";
import { researchTopicPage } from "./researchHubHtml";
import "./ResearchHub.css";

/**
 * One research question's own page: /research/models, /research/prompts,
 * /research/confidence.
 *
 * The page is researchTopicPage -- the same function public/seo.js calls for
 * the HTML crawlers receive -- so the two are one page, word for word.
 */
const ResearchTopic = ({ topic }) => {
  const [stats, setStats] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;
    getResearchStats()
      .then((s) => { if (live) { if (s && s.totals) setStats(s); else setFailed(true); } })
      .catch(() => { if (live) setFailed(true); });
    return () => { live = false; };
  }, []);

  const page = useMemo(() => (stats ? researchTopicPage(topic, stats) : null), [stats, topic]);

  useEffect(() => {
    if (page) document.title = page.title;
  }, [page]);

  // The same clearance under the fixed navbar as /research.
  return (
    <div className="page-content" style={{ paddingTop: 118 }}>
      <Container fluid>
        <Row className="justify-content-center">
          <Col xxl={10}>
            {page ? (
              <>
                <div className="research-hub">
                  <h1 className="hub-h1">{page.h1}</h1>
                </div>
                <div dangerouslySetInnerHTML={{ __html: page.html }} />
              </>
            ) : (
              <p className="text-muted text-center py-5">
                {failed ? "The research figures could not be loaded. Please try again shortly." : "Loading…"}
              </p>
            )}
            <div className="research-hub"><ResearchDisclaimer className="my-3" /></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ResearchTopic;
